import React from "react";
import styled, { css } from "styled-components";

import {
  Wrapper,
  Block,
  Content,
  ContentWrapper,
  CardsWrapper,
  CardRow,
  CardFooter,
  ArrowLinkWrapper,
  Offset,
  Gap,
} from "./Styles";
import LinkButton from "../../Buttons/NewButton/LinkButton";
import Container from "../../UI/Container";
import frame129 from "../../../images/Frame 129.png";
import landingVideo from "../../../videos/landingVideo.mp4";
import Card from "../../Dashboard/UI/Card";
import card1Icon from "../../../images/card1.png";
import card2Icon from "../../../images/card2.png";
import card3Icon from "../../../images/card3.png";
import card4Icon from "../../../images/card4.png";
import ebene_1 from "../../../images/Ebene_1_card.svg";
import { Link } from "react-router-dom";

const Accompaniments = ({ USER }) => {
  return (
    <Container gutter="medium">
      <Wrapper>
        <Block centered>
          <Content accompaniment>
            <h3>Establish long-term partnerships</h3>
            <p>
              Maximize the use of available transport resources and optimize
              logistics operations
            </p>
            <Gap />
            <img width={"90%"} src={frame129} alt="" />
          </Content>
        </Block>
        <Offset x={"-8rem"}></Offset>
        <Block column>
          <ContentWrapper background={"#F4F8FF"}>
            <Content>
              <h3>Reasons to choose TransConnector</h3>
            </Content>
            <CardsWrapper>
              <CardRow>
                <Card
                  className={"landing-white"}
                  title="Instant Payment"
                  icon={card1Icon}
                >
                  By using the customised Invoitix factoring solutions the
                  waiting for incoming payments from your customers is over.
                  <ArrowLinkWrapper>
                    <Link to="/instant-payment">→</Link>
                  </ArrowLinkWrapper>
                </Card>
                <Card
                  className={"landing-white"}
                  title="CMR Insurance"
                  icon={card2Icon}
                >
                  Freight Services Liability insurance
                </Card>
              </CardRow>
              <CardRow offset>
                <Card
                  className={"landing-white"}
                  title="Ferry bookings"
                  icon={card3Icon}
                >
                  We will help to obtain the freight transport tickets for
                  ferries, bridges and tunnels by the best terms
                </Card>
                <Card
                  className={"landing-white"}
                  title="Fuel Cards"
                  icon={card4Icon}
                >
                  Fuel cards are an ideal way to control the costs associated
                  with refuelling.
                </Card>
              </CardRow>
            </CardsWrapper>
          </ContentWrapper>
          <Offset className={"clipped"} x="-230px" y="-346px" height="0">
            <video autoPlay loop muted>
              <source src={landingVideo} type="video/mp4" />
            </video>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="0"
              height="0"
              viewBox="0 0 0 0"
              fill="none"
            >
              <defs>
                <clipPath
                  id="clip"
                  style={{ transform: "translate(169px, 0px)" }}
                >
                  <path d="M33.2767 26C33.2767 11.6406 44.9173 0 59.2767 0H215.731C230.09 0 241.731 11.6406 241.731 26V32.3967C241.731 46.7561 253.372 58.3967 267.731 58.3967H430.826C445.185 58.3967 456.826 70.0373 456.826 84.3968V377.603C456.826 391.962 445.185 403.603 430.826 403.603H365.713C351.353 403.603 339.713 415.244 339.713 429.603V455C339.713 469.359 328.072 481 313.713 481H157.258C142.899 481 131.258 469.359 131.258 455V429.603C131.258 415.244 119.618 403.603 105.258 403.603H26C11.6406 403.603 0 391.962 0 377.603V75.0351C0 65.846 7.44924 58.3967 16.6384 58.3967C25.8275 58.3967 33.2767 50.9475 33.2767 41.7584V26Z" />
                </clipPath>
              </defs>
            </svg>
          </Offset>
        </Block>
      </Wrapper>
    </Container>
  );
};

export const magGlass = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="233.902"
    height="232.054"
    viewBox="0 0 233.902 232.054"
  >
    <g transform="translate(0)">
      <path
        d="M881.175,346.759A74.353,74.353,0,0,0,906.81,212.236a74.357,74.357,0,1,1-64.386,132.478A73.87,73.87,0,0,0,881.175,346.759Z"
        transform="translate(-732.458 -203.415)"
        fill="#e2e5ec"
      />
      <path
        d="M847.885,406.394l78.508-72.047A80.972,80.972,0,1,1,949.26,357.9l-71.723,78.153a20.808,20.808,0,0,1-15.01,6.791c-.159,0-.312.006-.465.006a20.992,20.992,0,0,1-14.177-36.456Zm160.991-48.329a68.3,68.3,0,0,0-14.287-135.043,68.395,68.395,0,0,0-66.872,82.727,68.28,68.28,0,0,0,81.16,52.316ZM855.895,428.042a9.019,9.019,0,0,0,6.37,2.554,8.638,8.638,0,0,0,6.246-2.823l70.069-76.346-6.062-6.069-76.353,70.057a8.76,8.76,0,0,0-.27,12.627Z"
        transform="translate(-841.089 -210.796)"
        fill="#2f4265"
      />
    </g>
  </svg>
);

const tender = (
  <svg width="633" height="477" viewBox="0 0 633 477">
    <defs>
      <filter
        id="Rectangle_1478"
        x="0"
        y="0"
        width="633"
        height="477"
        filterUnits="userSpaceOnUse"
      >
        <feOffset dy="3" input="SourceAlpha" />
        <feGaussianBlur stdDeviation="13.5" result="blur" />
        <feFlood floodColor="#97c6ef" floodOpacity="0.122" />
        <feComposite operator="in" in2="blur" />
        <feComposite in="SourceGraphic" />
      </filter>
    </defs>
    <g
      id="Group_976"
      data-name="Group 976"
      transform="translate(-1177.5 -1710.5)"
    >
      <g
        transform="matrix(1, 0, 0, 1, 1177.5, 1710.5)"
        filter="url(#Rectangle_1478)"
      >
        <rect
          id="Rectangle_1478-2"
          data-name="Rectangle 1478"
          width="552"
          height="396"
          rx="7"
          transform="translate(40.5 37.5)"
          fill="#fff"
        />
      </g>
      <path
        id="Path_1161"
        data-name="Path 1161"
        d="M-19.214,0l.951-2.678h3.822L-13.489,0h1.2l-3.472-9.455h-1.182L-20.414,0ZM-17.9-3.693l1.514-4.266h.074L-14.8-3.693ZM-6.491-2.9A1.842,1.842,0,0,1-8.319-.96a1.546,1.546,0,0,1-1.551-1.7V-7.091H-10.96v4.506c0,1.81.96,2.678,2.29,2.678A2.211,2.211,0,0,0-6.565-1.2h.074V0H-5.4V-7.091H-6.491ZM-.323-7.091H-1.837v-1.7H-2.927v1.7H-4v.923h1.071v4.432A1.813,1.813,0,0,0-1.006.092,2.267,2.267,0,0,0-.194-.037l-.222-.979A2.1,2.1,0,0,1-.9-.96c-.48,0-.942-.148-.942-1.071V-6.168H-.323ZM2.558-4.266A1.782,1.782,0,0,1,4.423-6.2,1.567,1.567,0,0,1,6.066-4.432V0H7.156V-4.506c0-1.824-.969-2.678-2.419-2.678a2.058,2.058,0,0,0-2.087,1.2H2.558V-9.455H1.468V0H2.558ZM12.031.148c1.92,0,3.213-1.459,3.213-3.656,0-2.216-1.293-3.675-3.213-3.675S8.817-5.724,8.817-3.509C8.817-1.311,10.11.148,12.031.148Zm0-.979c-1.459,0-2.124-1.256-2.124-2.678s.665-2.7,2.124-2.7,2.124,1.274,2.124,2.7S13.489-.831,12.031-.831ZM16.906,0H18V-4.487a1.677,1.677,0,0,1,1.791-1.662,3.331,3.331,0,0,1,.665.074V-7.183c-.125-.009-.411-.018-.572-.018A1.93,1.93,0,0,0,18.032-6.02h-.074V-7.091H16.906Z"
        transform="translate(1351 2026)"
        fill="#686a7d"
      />
      <path
        id="Rectangle_1479"
        data-name="Rectangle 1479"
        d="M7,0H545a7,7,0,0,1,7,7V214a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V7A7,7,0,0,1,7,0Z"
        transform="translate(1218 1748)"
        fill="#f6f9fd"
      />
      <path
        id="Path_1160"
        data-name="Path 1160"
        d="M-10.387,0c2.881,0,4.506-1.791,4.506-4.746,0-2.936-1.625-4.709-4.376-4.709H-13.3V0ZM-12.16-1.016V-8.439h1.828c2.216,0,3.342,1.4,3.342,3.693,0,2.308-1.126,3.73-3.472,3.73ZM-2.022.166A2.228,2.228,0,0,0,.083-.96H.138V0H1.228V-4.672A2.33,2.33,0,0,0-1.394-7.183,2.88,2.88,0,0,0-4.238-5.521l1.034.369A1.916,1.916,0,0,1-1.357-6.223a1.317,1.317,0,0,1,1.5,1.44v.037c0,.526-.536.48-1.828.646-1.316.171-2.751.462-2.751,2.087A2.191,2.191,0,0,0-2.022.166Zm.166-.979c-.868,0-1.5-.388-1.5-1.145,0-.831.757-1.089,1.607-1.2A5.6,5.6,0,0,0,.138-3.564v1A1.82,1.82,0,0,1-1.856-.812ZM6.306-7.091H4.792v-1.7H3.7v1.7H2.631v.923H3.7v4.432A1.813,1.813,0,0,0,5.623.092a2.267,2.267,0,0,0,.813-.129l-.222-.979a2.1,2.1,0,0,1-.48.055c-.48,0-.942-.148-.942-1.071V-6.168H6.306ZM10.849.148a2.758,2.758,0,0,0,2.825-1.791l-1.053-.3A1.736,1.736,0,0,1,10.849-.831,2.148,2.148,0,0,1,8.637-3.176h5.147v-.462c0-2.641-1.57-3.545-3.047-3.545-1.92,0-3.195,1.514-3.195,3.693S8.8.148,10.849.148ZM8.637-4.118a2.117,2.117,0,0,1,2.1-2.087,1.922,1.922,0,0,1,1.939,2.087Z"
        transform="translate(1256 2026)"
        fill="#686a7d"
      />
      <path
        id="Path_1162"
        data-name="Path 1162"
        d="M-15.516,0h2V-3.065h1.68c2.174,0,3.439-1.3,3.439-3.185a3.082,3.082,0,0,0-3.388-3.2h-3.73Zm2-4.667V-7.82h1.348a1.493,1.493,0,0,1,1.713,1.57,1.5,1.5,0,0,1-1.7,1.583ZM-7.132,0h1.967V-4.012a1.432,1.432,0,0,1,1.5-1.473,3.308,3.308,0,0,1,.831.106V-7.123a2.952,2.952,0,0,0-.619-.069,1.722,1.722,0,0,0-1.7,1.339h-.074V-7.091H-7.132Zm5.314,0H.148V-7.091H-1.819Zm.988-8A1.036,1.036,0,0,0,.235-9,1.035,1.035,0,0,0-.831-9.995,1.034,1.034,0,0,0-1.893-9,1.035,1.035,0,0,0-.831-8ZM4.921.138A2.873,2.873,0,0,0,8.088-2.6H6.232A1.263,1.263,0,0,1,4.944-1.417c-.919,0-1.514-.771-1.514-2.128,0-1.339.6-2.105,1.514-2.105A1.264,1.264,0,0,1,6.232-4.469H8.088A2.875,2.875,0,0,0,4.912-7.183,3.359,3.359,0,0,0,1.431-3.518,3.351,3.351,0,0,0,4.921.138Zm7.663,0c1.754,0,2.936-.854,3.213-2.17l-1.819-.12a1.335,1.335,0,0,1-1.362.822A1.542,1.542,0,0,1,11.01-3.038v0h4.829v-.54c0-2.41-1.459-3.6-3.333-3.6a3.358,3.358,0,0,0-3.439,3.67A3.323,3.323,0,0,0,12.585.138Zm-1.574-4.4a1.5,1.5,0,0,1,1.528-1.454,1.4,1.4,0,0,1,1.45,1.454Z"
        transform="translate(1425 2026)"
        fill="#686a7d"
      />
      <path
        id="Path_1163"
        data-name="Path 1163"
        d="M-19.934-8.439h2.973V0h1.145V-8.439h2.973V-9.455h-7.091ZM-11.957,0h1.089V-4.487A1.677,1.677,0,0,1-9.076-6.149a3.331,3.331,0,0,1,.665.074V-7.183c-.125-.009-.411-.018-.572-.018A1.93,1.93,0,0,0-10.83-6.02H-10.9V-7.091h-1.053ZM-2.65-2.9A1.842,1.842,0,0,1-4.478-.96a1.546,1.546,0,0,1-1.551-1.7V-7.091H-7.119v4.506c0,1.81.96,2.678,2.29,2.678A2.211,2.211,0,0,0-2.724-1.2h.074V0H-1.56V-7.091H-2.65ZM3.315.148A2.631,2.631,0,0,0,6.1-2.068H5.013a1.65,1.65,0,0,1-1.7,1.237C2.022-.831,1.191-1.9,1.191-3.545c0-1.607.849-2.659,2.124-2.659a1.663,1.663,0,0,1,1.7,1.237H6.1A2.642,2.642,0,0,0,3.3-7.183C1.376-7.183.1-5.669.1-3.509.1-1.385,1.32.148,3.315.148ZM7.691,0H8.781V-2.654l.762-.706L12.2,0h1.385L10.364-4.062l3-3.028H12.012L8.91-3.933H8.781V-9.455H7.691Zm12.1-5.5a2.39,2.39,0,0,0-2.511-1.68c-1.5,0-2.6.849-2.6,2.05,0,.979.582,1.634,1.884,1.939l1.182.277c.716.166,1.053.508,1.053,1,0,.609-.646,1.108-1.662,1.108a1.5,1.5,0,0,1-1.643-1.145L14.45-1.7a2.437,2.437,0,0,0,2.7,1.847c1.648,0,2.77-.9,2.77-2.124,0-.988-.619-1.611-1.884-1.92l-1.053-.259c-.84-.208-1.219-.489-1.219-1.034,0-.609.646-1.053,1.514-1.053a1.491,1.491,0,0,1,1.533,1.016Z"
        transform="translate(1512 2026)"
        fill="#686a7d"
      />
      <path
        id="Path_1157"
        data-name="Path 1157"
        d="M614.285,633.5h16.456"
        transform="translate(862.711 1241.194)"
        fill="none"
        stroke="#747474"
        strokeWidth="2"
      />
      <path
        id="Path_1158"
        data-name="Path 1158"
        d="M628.76,623l5.361,5.361"
        transform="translate(859.34 1246.507)"
        fill="none"
        stroke="#747474"
        strokeWidth="2"
      />
      <path
        id="Path_1159"
        data-name="Path 1159"
        d="M628.76,638.147l5.358-5.715"
        transform="translate(859.34 1241.734)"
        fill="none"
        stroke="#747474"
        strokeWidth="2"
      />
      <line
        id="Line_489"
        data-name="Line 489"
        x2="510"
        transform="translate(1241.5 2034.5)"
        fill="none"
        stroke="#9aabc2"
        strokeWidth="1"
      />
      <path
        id="Path_1167"
        data-name="Path 1167"
        d="M-20.857-8.439h2.973V0h1.145V-8.439h2.973V-9.455h-7.091ZM-10.2.148A2.758,2.758,0,0,0-7.377-1.643l-1.053-.3A1.736,1.736,0,0,1-10.2-.831a2.148,2.148,0,0,1-2.211-2.345h5.147v-.462c0-2.641-1.57-3.545-3.047-3.545-1.92,0-3.195,1.514-3.195,3.693S-12.252.148-10.2.148Zm-2.211-4.266a2.117,2.117,0,0,1,2.1-2.087A1.922,1.922,0,0,1-8.374-4.118Zm7.9-.148A1.758,1.758,0,0,1-2.705-6.2,1.567,1.567,0,0,1-1.08-4.432V0H.009V-4.506c0-1.81-.965-2.678-2.4-2.678a2.093,2.093,0,0,0-2.068,1.2h-.092V-7.091H-5.6V0h1.089ZM4.681.148A2.194,2.194,0,0,0,6.749-1.089h.129V0H7.931V-9.455H6.842v3.49H6.749A2.159,2.159,0,0,0,4.7-7.183c-1.791,0-3.028,1.422-3.028,3.656C1.671-1.274,2.908.148,4.681.148Zm.148-.979c-1.366,0-2.068-1.2-2.068-2.714,0-1.5.683-2.659,2.068-2.659,1.33,0,2.031,1.071,2.031,2.659C6.86-1.939,6.14-.831,4.829-.831Zm8.217.979a2.758,2.758,0,0,0,2.825-1.791l-1.053-.3A1.736,1.736,0,0,1,13.046-.831a2.148,2.148,0,0,1-2.211-2.345h5.147v-.462c0-2.641-1.57-3.545-3.047-3.545-1.92,0-3.195,1.514-3.195,3.693S11,.148,13.046.148ZM10.835-4.118a2.117,2.117,0,0,1,2.1-2.087,1.922,1.922,0,0,1,1.939,2.087ZM17.644,0h1.089V-4.487a1.677,1.677,0,0,1,1.791-1.662,3.331,3.331,0,0,1,.665.074V-7.183c-.125-.009-.411-.018-.572-.018A1.93,1.93,0,0,0,18.771-6.02H18.7V-7.091H17.644Z"
        transform="translate(1262.902 1879)"
        fill="#686a7d"
      />
      <path
        id="Path_1165"
        data-name="Path 1165"
        d="M-9.972-4.727c0-2.991-1.754-4.857-4.173-4.857s-4.173,1.865-4.173,4.857S-16.564.129-14.145.129-9.972-1.736-9.972-4.727Zm-1.108,0c0,2.456-1.348,3.786-3.065,3.786s-3.065-1.33-3.065-3.786,1.348-3.786,3.065-3.786S-11.08-7.183-11.08-4.727Zm6.038-2.364H-6.629v-.72c0-.7.3-1.071,1.016-1.071A1.678,1.678,0,0,1-5-8.771l.314-.942A2.534,2.534,0,0,0-5.724-9.9,1.836,1.836,0,0,0-7.719-8.07v.979H-8.864v.923h1.145V0h1.089V-6.168h1.588Zm4.69,0H-1.939v-.72c0-.7.3-1.071,1.016-1.071a1.678,1.678,0,0,1,.609.111L0-9.713A2.534,2.534,0,0,0-1.034-9.9,1.836,1.836,0,0,0-3.028-8.07v.979H-4.173v.923h1.145V0h1.089V-6.168H-.351ZM3.859.148A2.758,2.758,0,0,0,6.685-1.643l-1.053-.3A1.736,1.736,0,0,1,3.859-.831,2.148,2.148,0,0,1,1.648-3.176H6.8v-.462c0-2.641-1.57-3.545-3.047-3.545C1.828-7.183.554-5.669.554-3.49S1.81.148,3.859.148ZM1.648-4.118A2.117,2.117,0,0,1,3.749-6.2,1.922,1.922,0,0,1,5.688-4.118ZM8.457,0H9.547V-4.487a1.677,1.677,0,0,1,1.791-1.662A3.331,3.331,0,0,1,12-6.075V-7.183c-.125-.009-.411-.018-.572-.018A1.93,1.93,0,0,0,9.584-6.02H9.51V-7.091H8.457Zm9.861-5.5a2.39,2.39,0,0,0-2.511-1.68c-1.5,0-2.6.849-2.6,2.05,0,.979.582,1.634,1.884,1.939l1.182.277c.716.166,1.053.508,1.053,1,0,.609-.646,1.108-1.662,1.108a1.5,1.5,0,0,1-1.643-1.145L12.982-1.7a2.437,2.437,0,0,0,2.7,1.847c1.648,0,2.77-.9,2.77-2.124,0-.988-.619-1.611-1.884-1.92l-1.053-.259c-.84-.208-1.219-.489-1.219-1.034,0-.609.646-1.053,1.514-1.053a1.491,1.491,0,0,1,1.533,1.016Z"
        transform="translate(1432 1931)"
        fill="#686a7d"
      />
      <path
        id="Path_1166"
        data-name="Path 1166"
        d="M-22.768,0c2.881,0,4.506-1.791,4.506-4.746,0-2.936-1.625-4.709-4.376-4.709h-3.047V0Zm-1.773-1.016V-8.439h1.828c2.216,0,3.342,1.4,3.342,3.693,0,2.308-1.126,3.73-3.472,3.73ZM-13.517.148a2.758,2.758,0,0,0,2.825-1.791l-1.053-.3A1.736,1.736,0,0,1-13.517-.831a2.148,2.148,0,0,1-2.211-2.345h5.147v-.462c0-2.641-1.57-3.545-3.047-3.545-1.92,0-3.195,1.514-3.195,3.693S-15.567.148-13.517.148Zm-2.211-4.266a2.117,2.117,0,0,1,2.1-2.087,1.922,1.922,0,0,1,1.939,2.087Zm8.9,4.284A2.228,2.228,0,0,0-4.727-.96h.055V0h1.089V-4.672A2.33,2.33,0,0,0-6.2-7.183,2.88,2.88,0,0,0-9.048-5.521l1.034.369A1.916,1.916,0,0,1-6.168-6.223a1.317,1.317,0,0,1,1.5,1.44v.037c0,.526-.536.48-1.828.646-1.316.171-2.751.462-2.751,2.087A2.191,2.191,0,0,0-6.832.166Zm.166-.979c-.868,0-1.5-.388-1.5-1.145,0-.831.757-1.089,1.607-1.2a5.6,5.6,0,0,0,1.884-.406v1A1.82,1.82,0,0,1-6.666-.812Zm7.756.96A2.194,2.194,0,0,0,3.158-1.089h.129V0H4.339V-9.455H3.25v3.49H3.158a2.159,2.159,0,0,0-2.05-1.219c-1.791,0-3.028,1.422-3.028,3.656C-1.92-1.274-.683.148,1.089.148Zm.148-.979c-1.366,0-2.068-1.2-2.068-2.714,0-1.5.683-2.659,2.068-2.659,1.33,0,2.031,1.071,2.031,2.659C3.268-1.939,2.548-.831,1.237-.831ZM7.571-9.455H6.482V0H7.571ZM9.565,0h1.089V-7.091H9.565Zm.554-8.273a.761.761,0,0,0,.776-.739.761.761,0,0,0-.776-.739.761.761,0,0,0-.776.739A.761.761,0,0,0,10.119-8.273Zm3.619,4.007A1.758,1.758,0,0,1,15.548-6.2a1.567,1.567,0,0,1,1.625,1.773V0h1.089V-4.506c0-1.81-.965-2.678-2.4-2.678a2.093,2.093,0,0,0-2.068,1.2H13.7V-7.091H12.649V0h1.089ZM23.23.148a2.758,2.758,0,0,0,2.825-1.791L25-1.939A1.736,1.736,0,0,1,23.23-.831a2.148,2.148,0,0,1-2.211-2.345h5.147v-.462c0-2.641-1.57-3.545-3.047-3.545-1.92,0-3.195,1.514-3.195,3.693S21.18.148,23.23.148ZM21.019-4.118a2.117,2.117,0,0,1,2.1-2.087,1.922,1.922,0,0,1,1.939,2.087Z"
        transform="translate(1269 1931)"
        fill="#686a7d"
      />
      <rect
        id="Rectangle_1480"
        data-name="Rectangle 1480"
        width="158"
        height="19"
        rx="6"
        transform="translate(1302 1865)"
        fill="#c9cbe5"
      />
      <rect
        id="Rectangle_1483"
        data-name="Rectangle 1483"
        width="85"
        height="19"
        rx="6"
        transform="translate(1302 1917)"
        fill="#c9cbe5"
      />
      <rect
        id="Rectangle_1490"
        data-name="Rectangle 1490"
        width="54"
        height="19"
        rx="6"
        transform="translate(1242 2056)"
        fill="#dfdfdf"
      />
      <rect
        id="Rectangle_1484"
        data-name="Rectangle 1484"
        width="54"
        height="19"
        rx="6"
        transform="translate(1330 2056)"
        fill="#dfdfdf"
      />
      <rect
        id="Rectangle_1485"
        data-name="Rectangle 1485"
        width="54"
        height="19"
        rx="6"
        transform="translate(1409 2056)"
        fill="#dfdfdf"
      />
      <rect
        id="Rectangle_1486"
        data-name="Rectangle 1486"
        width="54"
        height="19"
        rx="6"
        transform="translate(1491 2056)"
        fill="#dfdfdf"
      />
      <rect
        id="Rectangle_1489"
        data-name="Rectangle 1489"
        width="54"
        height="19"
        rx="6"
        transform="translate(1491 2086)"
        fill="#dfdfdf"
      />
      <rect
        id="Rectangle_1482"
        data-name="Rectangle 1482"
        width="53"
        height="19"
        rx="6"
        transform="translate(1458 1917)"
        fill="#c9cbe5"
      />
      <rect
        id="Rectangle_1481"
        data-name="Rectangle 1481"
        width="143"
        height="19"
        rx="6"
        transform="translate(1510 1865)"
        fill="#c9cbe5"
      />
      <path
        id="Path_1164"
        data-name="Path 1164"
        d="M-21.107-6.5a3.685,3.685,0,0,0-3.8-3.084c-2.419,0-4.173,1.865-4.173,4.857S-27.33.129-24.911.129a3.685,3.685,0,0,0,3.8-3.084h-1.145A2.573,2.573,0,0,1-24.911-.942c-1.717,0-3.065-1.33-3.065-3.786s1.348-3.786,3.065-3.786A2.573,2.573,0,0,1-22.251-6.5Zm4.58,6.648c1.92,0,3.213-1.459,3.213-3.656,0-2.216-1.293-3.675-3.213-3.675S-19.74-5.724-19.74-3.509C-19.74-1.311-18.447.148-16.527.148Zm0-.979c-1.459,0-2.124-1.256-2.124-2.678s.665-2.7,2.124-2.7S-14.4-4.93-14.4-3.509-15.068-.831-16.527-.831ZM-11.652,0h1.089V-4.432A1.683,1.683,0,0,1-8.956-6.2a1.309,1.309,0,0,1,1.4,1.348V0h1.108V-4.616A1.483,1.483,0,0,1-4.875-6.2a1.325,1.325,0,0,1,1.44,1.459V0h1.089V-4.746c0-1.667-.9-2.437-2.161-2.437a2.241,2.241,0,0,0-2.124,1.2H-6.7a1.951,1.951,0,0,0-1.9-1.2,1.909,1.909,0,0,0-1.9,1.2H-10.6V-7.091h-1.053Zm11.3,0H.739V-4.432A1.683,1.683,0,0,1,2.345-6.2a1.309,1.309,0,0,1,1.4,1.348V0H4.857V-4.616A1.483,1.483,0,0,1,6.426-6.2a1.325,1.325,0,0,1,1.44,1.459V0H8.956V-4.746c0-1.667-.9-2.437-2.161-2.437a2.241,2.241,0,0,0-2.124,1.2H4.6a1.951,1.951,0,0,0-1.9-1.2,1.909,1.909,0,0,0-1.9,1.2H.7V-7.091H-.351ZM13.923.148a2.758,2.758,0,0,0,2.825-1.791l-1.053-.3A1.736,1.736,0,0,1,13.923-.831a2.148,2.148,0,0,1-2.211-2.345h5.147v-.462c0-2.641-1.57-3.545-3.047-3.545-1.92,0-3.195,1.514-3.195,3.693S11.874.148,13.923.148ZM11.712-4.118a2.117,2.117,0,0,1,2.1-2.087,1.922,1.922,0,0,1,1.939,2.087Zm7.9-.148A1.758,1.758,0,0,1,21.42-6.2a1.567,1.567,0,0,1,1.625,1.773V0h1.089V-4.506c0-1.81-.965-2.678-2.4-2.678a2.093,2.093,0,0,0-2.068,1.2h-.092V-7.091H18.521V0h1.089Zm9.6-2.825H27.7v-1.7H26.609v1.7H25.538v.923h1.071v4.432A1.813,1.813,0,0,0,28.53.092a2.267,2.267,0,0,0,.813-.129l-.222-.979a2.1,2.1,0,0,1-.48.055c-.48,0-.942-.148-.942-1.071V-6.168h1.514Z"
        transform="translate(1597.962 2026)"
        fill="#686a7d"
      />
      <rect
        id="Rectangle_1487"
        data-name="Rectangle 1487"
        width="187"
        height="19"
        rx="6"
        transform="translate(1564 2056)"
        fill="#dfdfdf"
      />
      <rect
        id="Rectangle_1488"
        data-name="Rectangle 1488"
        width="187"
        height="19"
        rx="6"
        transform="translate(1564 2081)"
        fill="#dfdfdf"
      />
      <rect
        id="Rectangle_1491"
        data-name="Rectangle 1491"
        width="113"
        height="19"
        rx="6"
        transform="translate(1564 2106)"
        fill="#dfdfdf"
      />
      <rect
        id="Rectangle_1492"
        data-name="Rectangle 1492"
        width="242"
        height="24"
        rx="6"
        transform="translate(1242 1803)"
        fill="#5987e1"
      />
    </g>
  </svg>
);

const notes = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="215.694"
    height="180.917"
    viewBox="0 0 215.694 180.917"
  >
    <g id="Group_973" transform="translate(-431.438 -556.851)">
      <path
        d="M641.082,602.424c0,9.278-13.07,16.8-29.188,16.8H461.627c-16.122,0-29.188-7.524-29.188-16.8"
        transform="translate(2.526 115.019)"
        fill="#e2e5ec"
      />
      <path
        d="M626.806,737.768H451.767a20.351,20.351,0,0,1-20.329-20.325V577.176a20.349,20.349,0,0,1,20.329-20.325H626.806a20.346,20.346,0,0,1,20.326,20.325V717.443A20.348,20.348,0,0,1,626.806,737.768ZM451.767,563.9a13.294,13.294,0,0,0-13.281,13.278V717.443a13.294,13.294,0,0,0,13.281,13.278H626.806a13.291,13.291,0,0,0,13.278-13.278V577.176A13.291,13.291,0,0,0,626.806,563.9Z"
        transform="translate(0 0)"
        fill="#2f4265"
      />
      <rect
        width="138.696"
        height="7.048"
        transform="translate(472.786 601.765)"
        fill="#2f4265"
      />
      <rect
        width="138.696"
        height="7.048"
        transform="translate(472.786 625.403)"
        fill="#2f4265"
      />
      <rect
        width="138.696"
        height="7.048"
        transform="translate(472.786 648.775)"
        fill="#2f4265"
      />
      <path
        d="M525.961,611.821h-54.1a8.524,8.524,0,0,1-8.513-8.514v-6.3a8.525,8.525,0,0,1,8.513-8.517h54.1a8.525,8.525,0,0,1,8.513,8.517v6.3A8.524,8.524,0,0,1,525.961,611.821Zm-54.1-16.284a1.47,1.47,0,0,0-1.466,1.469v6.3a1.465,1.465,0,0,0,1.466,1.466h54.1a1.465,1.465,0,0,0,1.466-1.466v-6.3a1.47,1.47,0,0,0-1.466-1.469Z"
        transform="translate(80.531 79.852)"
        fill="#2f4265"
      />
    </g>
  </svg>
);

const publish = (
  <svg width="480" height="534" viewBox="0 0 480 534">
    <defs>
      <filter
        id="Rectangle_768"
        x="0"
        y="0"
        width="480"
        height="534"
        filterUnits="userSpaceOnUse"
      >
        <feOffset dy="3" input="SourceAlpha" />
        <feGaussianBlur stdDeviation="13.5" result="blur" />
        <feFlood floodColor="#97c6ef" floodOpacity="0.161" />
        <feComposite operator="in" in2="blur" />
        <feComposite in="SourceGraphic" />
      </filter>
    </defs>
    <g
      id="Group_975"
      data-name="Group 975"
      transform="translate(-1422.888 5306.5)"
    >
      <g
        transform="matrix(1, 0, 0, 1, 1422.89, -5306.5)"
        filter="url(#Rectangle_768)"
      >
        <rect
          id="Rectangle_768-2"
          data-name="Rectangle 768"
          width="399"
          height="453"
          rx="7"
          transform="translate(40.5 37.5)"
          fill="#fff"
        />
      </g>
      <path
        id="Path_1169"
        data-name="Path 1169"
        d="M7.507,4.455H4.616l-3.6,2.28V9.462L4.347,7.374h.085V19H7.507Zm5.256,14.73a1.7,1.7,0,1,0,0-3.395,1.7,1.7,0,1,0,0,3.395Zm8.2-.185h3.075V13.844h2.244L29.034,19h3.395l-3.089-5.653a4.193,4.193,0,0,0,2.571-4.141c0-2.891-1.911-4.751-5.213-4.751H20.959Zm3.075-7.628v-4.4h2.074c1.776,0,2.635.788,2.635,2.237s-.859,2.166-2.621,2.166Zm14.737,7.841c3.31,0,5.369-2.266,5.369-5.625,0-3.381-2.06-5.639-5.369-5.639S33.4,10.207,33.4,13.588C33.4,16.947,35.462,19.213,38.771,19.213Zm.014-2.344c-1.527,0-2.308-1.4-2.308-3.3s.781-3.31,2.308-3.31c1.5,0,2.28,1.406,2.28,3.31S40.284,16.869,38.786,16.869Zm14.325-2.514a2.055,2.055,0,0,1-2.081,2.23A1.867,1.867,0,0,1,49.141,14.5V8.091H46.115v6.946c.007,2.55,1.5,4.105,3.693,4.105a3.348,3.348,0,0,0,3.31-2.124h.114V19h2.9V8.091H53.111ZM64.354,8.091H62.3V5.477H59.276V8.091H57.784v2.273h1.491v5.682c-.014,2.138,1.442,3.2,3.636,3.1a5.885,5.885,0,0,0,1.641-.284l-.476-2.251a4.133,4.133,0,0,1-.753.1c-.6,0-1.023-.227-1.023-1.065V10.364h2.053Zm6.825,11.122c2.7,0,4.517-1.314,4.943-3.338l-2.8-.185a2.055,2.055,0,0,1-2.1,1.264,2.372,2.372,0,0,1-2.472-2.628V14.32h7.429v-.831c0-3.707-2.244-5.54-5.128-5.54-3.21,0-5.291,2.28-5.291,5.646C65.767,17.054,67.82,19.213,71.179,19.213Zm-2.422-6.768a2.3,2.3,0,0,1,2.351-2.237,2.15,2.15,0,0,1,2.23,2.237Z"
        transform="translate(1481.518 -5192.198)"
        fill="#262a68"
      />
      <path
        id="Path_1172"
        data-name="Path 1172"
        d="M1.179,19H11.548V16.486H5.44v-.1l2.124-2.081c2.99-2.727,3.793-4.091,3.793-5.746,0-2.521-2.06-4.3-5.178-4.3-3.054,0-5.149,1.825-5.142,4.68H3.956a2.07,2.07,0,0,1,2.2-2.244,2.05,2.05,0,0,1,2.23,2.074c0,1.158-.71,1.953-2.031,3.224L1.179,16.784Zm14.4.185a1.7,1.7,0,1,0,0-3.395,1.7,1.7,0,1,0,0,3.395Zm8.2-.185h3.075V12.991h5.916V10.456H26.847V6.99H33.4V4.455H23.771Zm11.456,0h3.026V12.828a2.2,2.2,0,0,1,2.315-2.266,5.089,5.089,0,0,1,1.278.163V8.041a4.541,4.541,0,0,0-.952-.107,2.65,2.65,0,0,0-2.621,2.06h-.114v-1.9H35.227Zm12.635.213c2.7,0,4.517-1.314,4.943-3.338l-2.8-.185a2.055,2.055,0,0,1-2.1,1.264,2.372,2.372,0,0,1-2.472-2.628V14.32h7.429v-.831c0-3.707-2.244-5.54-5.128-5.54-3.21,0-5.291,2.28-5.291,5.646C42.45,17.054,44.5,19.213,47.862,19.213ZM45.44,12.445a2.3,2.3,0,0,1,2.351-2.237,2.15,2.15,0,0,1,2.23,2.237ZM54.844,19h3.026V8.091H54.844Zm1.52-12.315A1.594,1.594,0,0,0,58,5.151a1.641,1.641,0,0,0-3.274,0A1.592,1.592,0,0,0,56.364,6.685ZM65.2,23.247c3.118,0,5.334-1.42,5.334-4.141V8.091h-3V9.923h-.114A3.236,3.236,0,0,0,64.3,7.949c-2.393,0-4.418,1.861-4.418,5.575,0,3.629,1.967,5.32,4.425,5.32a3.168,3.168,0,0,0,3.111-1.776h.128v2c0,1.428-.959,2.01-2.273,2.01A2.227,2.227,0,0,1,63.011,19.9l-2.8.376C60.575,21.926,62.259,23.247,65.2,23.247Zm.064-6.676c-1.484,0-2.294-1.179-2.294-3.061,0-1.854.8-3.153,2.294-3.153,1.47,0,2.294,1.243,2.294,3.153S66.719,16.571,65.263,16.571Zm10.71-3.878a2.031,2.031,0,0,1,2.1-2.23,1.866,1.866,0,0,1,1.946,2.131V19h3.026V12.054c.007-2.557-1.5-4.105-3.771-4.105a3.224,3.224,0,0,0-3.26,2.067h-.128V4.455h-2.94V19h3.026Zm15.263-4.6H89.183V5.477H86.158V8.091H84.666v2.273h1.491v5.682c-.014,2.138,1.442,3.2,3.636,3.1a5.885,5.885,0,0,0,1.641-.284l-.476-2.251a4.133,4.133,0,0,1-.753.1c-.6,0-1.023-.227-1.023-1.065V10.364h2.053Z"
        transform="translate(1481.518 -4970.029)"
        fill="#262a68"
      />
      <path
        id="Path_1168"
        data-name="Path 1168"
        d="M3.771,0l1.08-3.317H10.1L11.179,0h3.3L9.46-14.545H5.5L.476,0ZM5.632-5.717l1.79-5.5h.114l1.79,5.5ZM19.673.178a3.225,3.225,0,0,0,3.1-1.925H22.9V0h2.983V-14.545H22.862v5.469H22.77a3.214,3.214,0,0,0-3.1-1.974c-2.393,0-4.418,1.861-4.418,5.611C15.249-1.79,17.188.178,19.673.178Zm.959-2.408c-1.484,0-2.294-1.321-2.294-3.224s.8-3.189,2.294-3.189c1.47,0,2.294,1.243,2.294,3.189S22.088-2.23,20.632-2.23ZM32.379.178a3.225,3.225,0,0,0,3.1-1.925H35.6V0h2.983V-14.545H35.568v5.469h-.092a3.214,3.214,0,0,0-3.1-1.974c-2.393,0-4.418,1.861-4.418,5.611C27.955-1.79,29.893.178,32.379.178Zm.959-2.408c-1.484,0-2.294-1.321-2.294-3.224s.8-3.189,2.294-3.189c1.47,0,2.294,1.243,2.294,3.189S34.794-2.23,33.338-2.23Z"
        transform="translate(1524.389 -5236)"
        fill="#262a68"
      />
      <g
        id="Group_537"
        data-name="Group 537"
        transform="translate(1481.56 -5247.694)"
      >
        <path
          id="Path_672"
          data-name="Path 672"
          d="M14.647,6.688H2.291a.985.985,0,0,1,0-1.97H14.647a.985.985,0,1,1,0,1.97Z"
          transform="translate(-1.306 -4.718)"
          fill="#e13505"
        />
        <path
          id="Path_673"
          data-name="Path 673"
          d="M14.647,10.66H2.291a.985.985,0,1,1,0-1.97H14.647a.985.985,0,1,1,0,1.97Z"
          transform="translate(-1.306 -4.097)"
          fill="#e13505"
        />
        <path
          id="Path_674"
          data-name="Path 674"
          d="M10.269,14.632H2.291a.985.985,0,1,1,0-1.97h7.978a.985.985,0,1,1,0,1.97Z"
          transform="translate(-1.306 -3.476)"
          fill="#e13505"
        />
        <path
          id="Path_675"
          data-name="Path 675"
          d="M22.3,14.993H13.911a.985.985,0,1,1,0-1.97H22.3a.985.985,0,1,1,0,1.97Z"
          transform="translate(-1.482 -3.482)"
          fill="#e13505"
        />
        <path
          id="Path_676"
          data-name="Path 676"
          d="M18.171,19.123a.984.984,0,0,1-.985-.985V9.749a.985.985,0,0,1,1.97,0v8.389A.985.985,0,0,1,18.171,19.123Z"
          transform="translate(-1.546 -3.417)"
          fill="#e13505"
        />
      </g>
      <path
        id="Path_1170"
        data-name="Path 1170"
        d="M.881,0H5.142V-.781H1.761V-7.273H.881ZM8.608.114A2.512,2.512,0,0,0,11.08-2.7c0-1.7-.994-2.827-2.472-2.827S6.136-4.4,6.136-2.7A2.512,2.512,0,0,0,8.608.114Zm0-.753c-1.122,0-1.634-.966-1.634-2.06s.511-2.074,1.634-2.074,1.634.98,1.634,2.074S9.73-.639,8.608-.639Zm5.355.767a1.714,1.714,0,0,0,1.619-.866h.043V0h.838V-3.594a1.792,1.792,0,0,0-2.017-1.932,2.215,2.215,0,0,0-2.187,1.278l.8.284a1.474,1.474,0,0,1,1.42-.824,1.013,1.013,0,0,1,1.151,1.108v.028c0,.4-.412.369-1.406.5C13.207-3.022,12.1-2.8,12.1-1.548A1.686,1.686,0,0,0,13.963.128Zm.128-.753c-.668,0-1.151-.3-1.151-.881,0-.639.582-.838,1.236-.923a4.306,4.306,0,0,0,1.449-.313v.767A1.4,1.4,0,0,1,14.091-.625Zm5.966.739a1.687,1.687,0,0,0,1.591-.952h.1V0h.81V-7.273h-.838v2.685h-.071a1.661,1.661,0,0,0-1.577-.937c-1.378,0-2.33,1.094-2.33,2.812S18.693.114,20.057.114Zm.114-.753c-1.051,0-1.591-.923-1.591-2.088s.526-2.045,1.591-2.045c1.023,0,1.563.824,1.563,2.045S21.179-.639,20.17-.639ZM24.2,0h.838V-5.455H24.2Zm.426-6.364a.586.586,0,0,0,.6-.568.586.586,0,0,0-.6-.568.586.586,0,0,0-.6.568A.586.586,0,0,0,24.631-6.364Zm2.784,3.082a1.352,1.352,0,0,1,1.392-1.491,1.205,1.205,0,0,1,1.25,1.364V0h.838V-3.466c0-1.392-.742-2.06-1.847-2.06a1.61,1.61,0,0,0-1.591.923h-.071v-.852h-.81V0h.838Zm7.216,5.44c1.307,0,2.358-.6,2.358-2V-5.455h-.81v.866h-.085A1.686,1.686,0,0,0,34.5-5.526c-1.378,0-2.33,1.094-2.33,2.77,0,1.7.994,2.67,2.315,2.67a1.658,1.658,0,0,0,1.591-.923h.071V.1c0,.909-.639,1.321-1.52,1.321A1.707,1.707,0,0,1,33.068.6l-.668.469A2.4,2.4,0,0,0,34.631,2.159Zm-.028-3c-1.051,0-1.591-.8-1.591-1.932,0-1.108.526-2,1.591-2,1.023,0,1.563.824,1.563,2C36.165-1.562,35.611-.838,34.6-.838Zm4.531.895a.641.641,0,0,0,.639-.639.641.641,0,0,0-.639-.639.641.641,0,0,0-.639.639A.641.641,0,0,0,39.134.057Zm0-4.048a.641.641,0,0,0,.639-.639.641.641,0,0,0-.639-.639.641.641,0,0,0-.639.639A.641.641,0,0,0,39.134-3.991Z"
        transform="translate(1540.389 -5119)"
        fill="#313131"
      />
      <path
        id="Path_1173"
        data-name="Path 1173"
        d="M2.2,0h.909L4.716-5.8h.057L6.378,0h.909L9.276-7.273H8.381L6.861-1.349H6.79L5.241-7.273H4.247L2.7-1.349H2.628L1.108-7.273H.213Zm9.83.114A2.122,2.122,0,0,0,14.2-1.264l-.81-.227a1.335,1.335,0,0,1-1.364.852,1.652,1.652,0,0,1-1.7-1.8h3.96V-2.8c0-2.031-1.207-2.727-2.344-2.727-1.477,0-2.457,1.165-2.457,2.841A2.506,2.506,0,0,0,12.031.114Zm-1.7-3.281a1.629,1.629,0,0,1,1.616-1.605,1.479,1.479,0,0,1,1.491,1.605ZM15.568,0h.838V-5.455h-.838Zm.426-6.364a.586.586,0,0,0,.6-.568.586.586,0,0,0-.6-.568.586.586,0,0,0-.6.568A.586.586,0,0,0,15.994-6.364Zm4.148,8.523c1.307,0,2.358-.6,2.358-2V-5.455h-.81v.866h-.085a1.686,1.686,0,0,0-1.591-.937c-1.378,0-2.33,1.094-2.33,2.77,0,1.7.994,2.67,2.315,2.67a1.658,1.658,0,0,0,1.591-.923h.071V.1c0,.909-.639,1.321-1.52,1.321A1.707,1.707,0,0,1,18.58.6l-.668.469A2.4,2.4,0,0,0,20.142,2.159Zm-.028-3c-1.051,0-1.591-.8-1.591-1.932,0-1.108.526-2,1.591-2,1.023,0,1.563.824,1.563,2C21.676-1.562,21.122-.838,20.114-.838Zm4.759-2.443a1.371,1.371,0,0,1,1.435-1.491,1.205,1.205,0,0,1,1.264,1.364V0h.838V-3.466c0-1.4-.746-2.06-1.861-2.06a1.583,1.583,0,0,0-1.605.923h-.071v-2.67h-.838V0h.838Zm7.443-2.173H31.151V-6.761h-.838v1.307h-.824v.71h.824v3.409A1.4,1.4,0,0,0,31.79.071a1.744,1.744,0,0,0,.625-.1l-.17-.753a1.618,1.618,0,0,1-.369.043c-.369,0-.724-.114-.724-.824V-4.744h1.165ZM34.19.057a.641.641,0,0,0,.639-.639.641.641,0,0,0-.639-.639.641.641,0,0,0-.639.639A.641.641,0,0,0,34.19.057Zm0-4.048a.641.641,0,0,0,.639-.639.641.641,0,0,0-.639-.639.641.641,0,0,0-.639.639A.641.641,0,0,0,34.19-3.991Z"
        transform="translate(1540.389 -4908)"
        fill="#313131"
      />
      <path
        id="Path_1174"
        data-name="Path 1174"
        d="M.881,0h.881V-3.253H5.639V0H6.52V-7.273H5.639v3.239H1.761V-7.273H.881Zm9.574.114a2.122,2.122,0,0,0,2.173-1.378l-.81-.227a1.335,1.335,0,0,1-1.364.852,1.652,1.652,0,0,1-1.7-1.8h3.96V-2.8c0-2.031-1.207-2.727-2.344-2.727-1.477,0-2.457,1.165-2.457,2.841A2.506,2.506,0,0,0,10.455.114Zm-1.7-3.281a1.629,1.629,0,0,1,1.616-1.605,1.479,1.479,0,0,1,1.491,1.605ZM13.991,0h.838V-5.455h-.838Zm.426-6.364a.586.586,0,0,0,.6-.568.586.586,0,0,0-.6-.568.586.586,0,0,0-.6.568A.586.586,0,0,0,14.418-6.364Zm4.148,8.523c1.307,0,2.358-.6,2.358-2V-5.455h-.81v.866h-.085a1.686,1.686,0,0,0-1.591-.937c-1.378,0-2.33,1.094-2.33,2.77,0,1.7.994,2.67,2.315,2.67a1.658,1.658,0,0,0,1.591-.923h.071V.1c0,.909-.639,1.321-1.52,1.321A1.707,1.707,0,0,1,17,.6l-.668.469A2.4,2.4,0,0,0,18.565,2.159Zm-.028-3c-1.051,0-1.591-.8-1.591-1.932,0-1.108.526-2,1.591-2,1.023,0,1.563.824,1.563,2C20.1-1.562,19.545-.838,18.537-.838ZM23.3-3.281A1.371,1.371,0,0,1,24.73-4.773a1.205,1.205,0,0,1,1.264,1.364V0h.838V-3.466c0-1.4-.746-2.06-1.861-2.06a1.583,1.583,0,0,0-1.605.923H23.3v-2.67h-.838V0H23.3Zm7.443-2.173H29.574V-6.761h-.838v1.307h-.824v.71h.824v3.409A1.4,1.4,0,0,0,30.213.071a1.744,1.744,0,0,0,.625-.1l-.17-.753a1.618,1.618,0,0,1-.369.043c-.369,0-.724-.114-.724-.824V-4.744h1.165Z"
        transform="translate(1696.389 -4908)"
        fill="#313131"
      />
      <path
        id="Path_1171"
        data-name="Path 1171"
        d="M.881,0h.881V-2.656H3.352A2.2,2.2,0,0,0,5.81-4.972a2.193,2.193,0,0,0-2.472-2.3H.881Zm.881-3.437V-6.491H3.31c1.183,0,1.634.646,1.634,1.52A1.418,1.418,0,0,1,3.324-3.437ZM9.347.114A2.122,2.122,0,0,0,11.52-1.264l-.81-.227a1.335,1.335,0,0,1-1.364.852,1.652,1.652,0,0,1-1.7-1.8h3.96V-2.8c0-2.031-1.207-2.727-2.344-2.727C7.784-5.526,6.8-4.361,6.8-2.685A2.506,2.506,0,0,0,9.347.114Zm-1.7-3.281A1.629,1.629,0,0,1,9.261-4.773a1.479,1.479,0,0,1,1.491,1.605ZM12.884,0h.838V-3.452A1.29,1.29,0,0,1,15.1-4.73a2.562,2.562,0,0,1,.511.057v-.852c-.1-.007-.316-.014-.44-.014a1.484,1.484,0,0,0-1.42.909h-.057v-.824h-.81Zm3.722,0h.838V-5.455h-.838Zm.426-6.364a.586.586,0,0,0,.6-.568.586.586,0,0,0-.6-.568.586.586,0,0,0-.6.568A.586.586,0,0,0,17.031-6.364ZM21.193.114A2.512,2.512,0,0,0,23.665-2.7c0-1.7-.994-2.827-2.472-2.827S18.722-4.4,18.722-2.7A2.512,2.512,0,0,0,21.193.114Zm0-.753c-1.122,0-1.634-.966-1.634-2.06s.511-2.074,1.634-2.074,1.634.98,1.634,2.074S22.315-.639,21.193-.639ZM27,.114a1.687,1.687,0,0,0,1.591-.952h.1V0h.81V-7.273h-.838v2.685h-.071a1.661,1.661,0,0,0-1.577-.937c-1.378,0-2.33,1.094-2.33,2.812S25.639.114,27,.114Zm.114-.753c-1.051,0-1.591-.923-1.591-2.088s.526-2.045,1.591-2.045c1.023,0,1.563.824,1.563,2.045S28.125-.639,27.116-.639Zm9.062.753A2.512,2.512,0,0,0,38.651-2.7c0-1.7-.994-2.827-2.472-2.827S33.707-4.4,33.707-2.7A2.512,2.512,0,0,0,36.179.114Zm0-.753c-1.122,0-1.634-.966-1.634-2.06s.511-2.074,1.634-2.074,1.634.98,1.634,2.074S37.3-.639,36.179-.639Zm6.179-4.815H41.136v-.554c0-.54.227-.824.781-.824a1.291,1.291,0,0,1,.469.085l.241-.724a1.949,1.949,0,0,0-.8-.142A1.413,1.413,0,0,0,40.3-6.207v.753h-.881v.71H40.3V0h.838V-4.744h1.222Zm3.707-1.037h2.287V0h.881V-6.491H51.52v-.781H46.065ZM52.2,0h.838V-3.452A1.29,1.29,0,0,1,54.418-4.73a2.562,2.562,0,0,1,.511.057v-.852c-.1-.007-.316-.014-.44-.014a1.484,1.484,0,0,0-1.42.909h-.057v-.824H52.2Zm5.327.128a1.714,1.714,0,0,0,1.619-.866h.043V0h.838V-3.594a1.792,1.792,0,0,0-2.017-1.932,2.215,2.215,0,0,0-2.187,1.278l.8.284a1.474,1.474,0,0,1,1.42-.824A1.013,1.013,0,0,1,59.19-3.679v.028c0,.4-.412.369-1.406.5-1.012.131-2.116.355-2.116,1.605A1.686,1.686,0,0,0,57.528.128Zm.128-.753c-.668,0-1.151-.3-1.151-.881,0-.639.582-.838,1.236-.923a4.306,4.306,0,0,0,1.449-.313v.767A1.4,1.4,0,0,1,57.656-.625ZM62.4-3.281a1.352,1.352,0,0,1,1.392-1.491,1.205,1.205,0,0,1,1.25,1.364V0h.838V-3.466c0-1.392-.742-2.06-1.847-2.06a1.61,1.61,0,0,0-1.591.923h-.071v-.852h-.81V0H62.4Zm8.878-.952a1.838,1.838,0,0,0-1.932-1.293c-1.151,0-2,.653-2,1.577,0,.753.447,1.257,1.449,1.491l.909.213c.55.128.81.391.81.767,0,.469-.5.852-1.278.852a1.151,1.151,0,0,1-1.264-.881l-.8.2A1.875,1.875,0,0,0,69.247.114c1.268,0,2.131-.692,2.131-1.634,0-.76-.476-1.239-1.449-1.477l-.81-.2c-.646-.16-.937-.376-.937-.8,0-.469.5-.81,1.165-.81a1.147,1.147,0,0,1,1.179.781Zm1.364,6.278h.838V-.838h.071a1.687,1.687,0,0,0,1.591.952c1.364,0,2.315-1.094,2.315-2.827s-.952-2.812-2.33-2.812a1.661,1.661,0,0,0-1.577.937h-.1v-.866h-.81Zm.824-4.773c0-1.222.54-2.045,1.563-2.045,1.065,0,1.591.895,1.591,2.045S76.08-.639,75.028-.639C74.02-.639,73.466-1.491,73.466-2.727ZM80.952.114A2.512,2.512,0,0,0,83.423-2.7c0-1.7-.994-2.827-2.472-2.827S78.48-4.4,78.48-2.7A2.512,2.512,0,0,0,80.952.114Zm0-.753c-1.122,0-1.634-.966-1.634-2.06s.511-2.074,1.634-2.074,1.634.98,1.634,2.074S82.074-.639,80.952-.639ZM84.7,0h.838V-3.452A1.29,1.29,0,0,1,86.918-4.73a2.562,2.562,0,0,1,.511.057v-.852c-.1-.007-.316-.014-.44-.014a1.484,1.484,0,0,0-1.42.909h-.057v-.824H84.7Zm6.435-5.455H89.972V-6.761h-.838v1.307H88.31v.71h.824v3.409A1.4,1.4,0,0,0,90.611.071a1.744,1.744,0,0,0,.625-.1l-.17-.753a1.618,1.618,0,0,1-.369.043c-.369,0-.724-.114-.724-.824V-4.744h1.165Zm5.028,1.222a1.838,1.838,0,0,0-1.932-1.293c-1.151,0-2,.653-2,1.577,0,.753.447,1.257,1.449,1.491l.909.213c.55.128.81.391.81.767,0,.469-.5.852-1.278.852a1.151,1.151,0,0,1-1.264-.881l-.8.2A1.875,1.875,0,0,0,94.134.114c1.268,0,2.131-.692,2.131-1.634,0-.76-.476-1.239-1.449-1.477l-.81-.2c-.646-.16-.937-.376-.937-.8,0-.469.5-.81,1.165-.81a1.147,1.147,0,0,1,1.179.781ZM98.139.057a.641.641,0,0,0,.639-.639.641.641,0,0,0-.639-.639.641.641,0,0,0-.639.639A.641.641,0,0,0,98.139.057Zm0-4.048a.641.641,0,0,0,.639-.639.641.641,0,0,0-.639-.639.641.641,0,0,0-.639.639A.641.641,0,0,0,98.139-3.991Z"
        transform="translate(1482.389 -5050)"
        fill="#313131"
      />
      <rect
        id="Rectangle_1493"
        data-name="Rectangle 1493"
        width="147"
        height="13"
        rx="6"
        transform="translate(1611.388 -5129)"
        fill="#c9cbe5"
      />
      <rect
        id="Rectangle_1503"
        data-name="Rectangle 1503"
        width="38"
        height="13"
        rx="6"
        transform="translate(1594.388 -4917)"
        fill="#c9cbe5"
      />
      <rect
        id="Rectangle_1504"
        data-name="Rectangle 1504"
        width="38"
        height="13"
        rx="6"
        transform="translate(1739.388 -4917)"
        fill="#c9cbe5"
      />
      <rect
        id="Rectangle_1497"
        data-name="Rectangle 1497"
        width="56"
        height="13"
        rx="6"
        transform="translate(1610.388 -5060)"
        fill="#c9cbe5"
      />
      <rect
        id="Rectangle_1499"
        data-name="Rectangle 1499"
        width="105"
        height="8"
        rx="4"
        transform="translate(1610.388 -5026)"
        fill="#c9cbe5"
      />
      <rect
        id="Rectangle_1507"
        data-name="Rectangle 1507"
        width="105"
        height="7"
        rx="3.5"
        transform="translate(1594.388 -4868)"
        fill="#c9cbe5"
      />
      <rect
        id="Rectangle_1500"
        data-name="Rectangle 1500"
        width="105"
        height="8"
        rx="4"
        transform="translate(1610.388 -5008)"
        fill="#e6e8f6"
      />
      <rect
        id="Rectangle_1506"
        data-name="Rectangle 1506"
        width="105"
        height="7"
        rx="3.5"
        transform="translate(1594.388 -4854)"
        fill="#e6e8f6"
      />
      <rect
        id="Rectangle_1501"
        data-name="Rectangle 1501"
        width="105"
        height="7"
        rx="3.5"
        transform="translate(1610.388 -4991)"
        fill="#fafafa"
      />
      <rect
        id="Rectangle_1505"
        data-name="Rectangle 1505"
        width="105"
        height="8"
        rx="4"
        transform="translate(1594.388 -4841)"
        fill="#fafafa"
      />
      <rect
        id="Rectangle_1498"
        data-name="Rectangle 1498"
        width="47"
        height="13"
        rx="6"
        transform="translate(1705.388 -5060)"
        fill="#c9cbe5"
      />
      <rect
        id="Rectangle_1495"
        data-name="Rectangle 1495"
        width="91"
        height="9"
        rx="4.5"
        transform="translate(1611.388 -5087)"
        fill="#7f7f7f"
      />
    </g>
  </svg>
);

export default Accompaniments;
